import * as React from 'react';
import VelocityChart from './VelocityChart';
import RideJustStarted from '../RideJustStarted';
import { IGraphData, IGraphResponseData } from '../GraphService';

interface IProps {
  responseData: IGraphResponseData[];
  isCompressed: boolean;
  loadData: () => void;
  vehicleId: number;
  isSelectable: boolean;
  speedLimits: number[] | null;
}

function Stopped(props: IProps) {
  const [graphData, setGraphData] = React.useState<IGraphData>({
    xLabels: [],
    yLabels: [],
    tooltips: {},
    minLabels: [],
    maxLabels: [],
  });

  const getData = () => {
    const xLabels: string[] = [];
    const yLabels: (number | null)[] = [];
    const minLabels: string[] = [];
    const maxLabels: string[] = [];
    const tooltips = {};
    if (props.responseData) {
      props.responseData.forEach((i) => {
        if (!xLabels.includes(i.timestamp)) {
          xLabels.push(i.timestamp);
          yLabels.push(i.value);
          minLabels.push(i.min);
          maxLabels.push(i.max);
          tooltips[i.timestamp] = {
            address: i.address || `${i.latitude}, ${i.longitude}`,
            code: i.code,
          };
        }
      });
    }
    setGraphData({
      xLabels,
      yLabels,
      minLabels,
      maxLabels,
      tooltips,
    });
  };

  React.useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.responseData]);

  return (
    <div>
      <RideJustStarted vehicleId={props.vehicleId} loadData={props.loadData} />
      <VelocityChart
        graphData={graphData}
        noAnimation="animation"
        isCompressed={props.isCompressed}
        isSelectable={props.isSelectable}
        speedLimits={props.speedLimits}
      />
    </div>
  );
}

export default React.memo(Stopped);
